/**
 * 管理后台通用组件索引文件
 * 包含admin专用组件和共享组件
 */

import StatCard from './StatCard.vue';
import EmptyState from './EmptyState.vue';

// 从共享库导入组件
import { 
  registerGlobalComponents as registerSharedComponents,
  StudentSelector,
  DateRangePicker,
  DataTable,
  ConfirmDialog,
  FormGenerator
} from '@class-management/shared';

// 注册全局组件
export const registerGlobalComponents = (app) => {
  // 注册共享组件
  registerSharedComponents(app);
  // 注册admin专用组件
  app.component('StatCard', StatCard);
  app.component('EmptyState', EmptyState);
};

// 导出所有组件
export {
  StatCard,
  EmptyState,
  StudentSelector,
  DateRangePicker,
  DataTable,
  ConfirmDialog,
  FormGenerator
};

export default {
  install: (app) => {
    registerGlobalComponents(app);
  }
}; 